/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

export const LAST_REQUEST_TIME = 'lastRequestTime';
export const LOGGED_IN_FLAG = 'isLoggedIn';
export const TIMED_OUT_FLAG = 'isTimedOut';
